var _defs, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient1",
    cx: "50%",
    cy: "50%",
    fx: "0.441602%",
    fy: "50%",
    r: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fx",
    dur: "34s",
    values: "0%;3%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2dccd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255, 0, 255, 0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient2",
    cx: "50%",
    cy: "50%",
    fx: "2.68147%",
    fy: "50%",
    r: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fx",
    dur: "23.5s",
    values: "0%;3%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fcb61c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255, 255, 0, 0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient3",
    cx: "50%",
    cy: "50%",
    fx: "0.836536%",
    fy: "50%",
    r: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fx",
    dur: "21.5s",
    values: "0%;3%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(0, 255, 255, 0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient4",
    cx: "50%",
    cy: "50%",
    fx: "4.56417%",
    fy: "50%",
    r: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fx",
    dur: "23s",
    values: "0%;5%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(0, 255, 0, 1)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(0, 255, 0, 0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient5",
    cx: "50%",
    cy: "50%",
    fx: "2.65405%",
    fy: "50%",
    r: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fx",
    dur: "24.5s",
    values: "0%;5%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(0,0,255, 1)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(0,0,255, 0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient6",
    cx: "50%",
    cy: "50%",
    fx: "0.981338%",
    fy: "50%",
    r: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fx",
    dur: "25.5s",
    values: "0%;5%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "rgba(255,0,0, 1)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255,0,0, 0)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: "13.744%",
    y: "1.18473%",
    width: "100%",
    height: "100%",
    fill: "url(#Gradient1)",
    transform: "rotate(334.41 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    dur: "20s",
    values: "25%;0%;25%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "21s",
    values: "0%;25%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    dur: "7s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: "-2.17916%",
    y: "35.4267%",
    width: "100%",
    height: "100%",
    fill: "url(#Gradient2)",
    transform: "rotate(255.072 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    dur: "23s",
    values: "-25%;0%;-25%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "24s",
    values: "0%;50%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 50 50",
    to: "360 50 50",
    dur: "12s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: "9.00483%",
    y: "14.5733%",
    width: "100%",
    height: "100%",
    fill: "url(#Gradient3)",
    transform: "rotate(139.903 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "x",
    dur: "25s",
    values: "0%;25%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    dur: "12s",
    values: "0%;25%;0%",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "360 50 50",
    to: "0 50 50",
    dur: "9s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.6a0ff1fd068e617c136c981bd2410929.svg";
export { ForwardRef as ReactComponent };